
<!-- 2024年11.4 修改之前版本 -->
<template>
	<div class="com">
		<div class="room">
			<div class="tab-list">
				<em class="tit">教研空间</em>
				<span @click="changeType(i.code)" :class="activeCode===i.code ? 'active':'' " v-for="i in typeList" :key="i.code">{{i.name}}</span>
				<em class="more" @click="more">
					更多
					<i class="el-icon-arrow-right"></i>
				</em>
			</div>
			<div class="tab-content1" v-loading="pageLoading">
				<div class="score">
					<card-list v-if="['eduResearch', 'train', 'topicResearch'].includes(activeCode)" :moduleType="activeCode" :dataList="dataList" @delSuccess="selectEtt"></card-list>
					<!-- 我的空间 -->
					<div v-if="activeCode=='grkj'" class="space-table">
						<!-- 表格 -->
						<el-table empty-text="暂无更多..." element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)" :data="dataListKj" stripe style="width: 100%" :header-cell-style="{background:'#EFEFEF'}">
							<el-table-column prop="attachName" label="文件名称" width="170"></el-table-column>
							<el-table-column prop="name" label="类型" width="120">
								<template slot-scope="scope">
									<i v-if="scope.row.attachType" class="big-icon" :class="mapFileIcon(scope.row.attachType)"></i>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="上传时间"></el-table-column>
							<el-table-column prop="attachSize" label="文件大小">
								<template slot-scope="scope">{{scope.row.attachSize ? scope.row.attachSize + " kb" :""}}</template>
							</el-table-column>
							<el-table-column prop="name" label="操作">
								<template slot-scope="scope">
									<el-button type="text" @click="lookFile(scope.row.attachUrl)">预览</el-button>
									<el-divider direction="vertical"></el-divider>
									<el-button type="text" @click="downloadFile(scope.row.attachUrl,scope.row.attachName)">下载</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>

					<div v-if="['design', 'articles', 'radiation','share'].includes(activeCode)" class="infinite-list-wrapper">
						<ul class="list">
							<li v-for="(item,index) in darList" :key="index" class="list-item" @click="goZnDetail(item)">
								<div class="article-icon"></div>
								<div class="article-main">
									<div class="article-title mb-2px">{{item.title}}</div>
									<div class="article-uv">
										<span :title="item.browseCount+'次浏览'">
											<i class="el-icon-view"></i>
											{{item.browseCount}}
										</span>
										<span :title="item.downloadCount+'次下载'">
											<i class="el-icon-download"></i>
											{{item.downloadCount}}
										</span>
										<span :title="item.collectCount+'次收藏'">
											<i class="el-icon-star-off"></i>
											{{item.collectCount}}
										</span>
									</div>
								</div>
								<div class="article-date">上传者：{{item.createName}}<br> 作者：{{item.otherAuthor | otherAuthorFil }}<br> {{ item.createTime }}发布</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="room">
			<div class="tab-list">
				<em class="tit">智能推荐</em>
				<span @click="changeType2(i.code)" :class="znForm.sortBy===i.code ? 'active':'' " v-for="i in typeList2" :key="i.code">{{i.name}}</span>
				<em class="more" @click="znMore">
					更多
					<i class="el-icon-arrow-right"></i>
				</em>
			</div>
			<div class="tab-content2" v-loading="tjLoading">
				<div class="max-new">
					<el-row>
						<el-col class="new-list clearfix" :span="12" v-for="i,index in dataListTj" :key="index" @click.native="goZnDetail(i)">
							<div class="img-left fl">
								<img src="../../assets/image/other/hot.png" alt />
								<h3>{{i.browseCount?i.browseCount:'0'}}</h3>
							</div>
							<div class="fl">
								<h4>{{i.title}}</h4>
								<div class="tea-desc clearfix">
									<img :src="i.createLogo ? i.createLogo:userLogo" alt class="fl" />
									<span class="fl">{{i.createName}}</span>
									<span style="font-size:13px" class="school fl">{{i.schoolName}}</span>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CardList from "@/components/common/CardList.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
import { mapFileIcon, lookFile, downloadUrlFile } from "@/utils/index.js";
export default {
	components: {
		CardList
	},
	computed: {
		...mapState(["userInfo", "resOptions"]),
		...mapGetters(["schoolCodes"])
	},
	data() {
		return {
			userLogo: require("@/assets/image/other/man_teacher.png"),
			activeCode: "eduResearch",
			typeList: [
				{ code: "eduResearch", name: "教研活动" },
				{ code: "train", name: "培训" },
				{ code: "topicResearch", name: "项目课题研究" },
				// { code: "zyfx", name: "资源分享" },
				//教学设计"design"，学术文章"articles，示范辐射radiation
				{ code: "design", name: "教学设计" },
				{ code: "articles", name: "学术文章" },
				{ code: "radiation", name: "示范辐射" },
				// { code: "share", name: "资源分享" },
				{ code: "grkj", name: "个人空间" }
			],
			formThree: {
				actType: "research",
				activeStatus: 1, //进行中
				schoolCodes: [],
				classify1: "",
				classify2: "",
				checkIsMe: [], //无用
				isMe: "", // 空 全部
				keyword: "",
				operatorId: "",
				pageNum: 1,
				pageSize: 8
			},
			pageLoading: true,
			dataList: [],
			//教学设计 三个
			formDar: {
				bookVsns: null,
				disciplineCodes: null,
				gradeAndTerms: null,
				keyword: "",
				operatorId: "",
				pageNum: 1,
				pageSize: 11,
				schoolCodes: [],
				sortBy: "1" //0:最热,1:最新,2:收藏
			},
			darList: [],
			//个人空间
			dataListKj: [],
			//智能推荐
			tjLoading: false,
			typeList2: [
				{ code: "0", name: "最新" },
				{ code: "1", name: "最热" }
			],
			znForm: {
				pageNum: 1,
				pageSize: 14,
				schoolCodes: "",
				userId: "",
				sortBy: "0" //0最新 1最热2:收藏
			},
			dataListTj: []
		};
	},
	created() {
		this.init();
	},
	methods: {
		mapFileIcon,
		lookFile,
		downloadUrlFile,
		init() {
			this.changeType("eduResearch");
			this.selectTj();
		},
		changeType(code) {
			this.activeCode = code;
			if (["eduResearch", "train", "topicResearch"].includes(code)) {
				this.selectEtt();
			} else if (["design", "articles", "radiation", "share"].includes(code)) {
				this.selectDar();
			} else if (code === "grkj") {
				this.getGrkj();
			}
		},
		//教研活动 培训 项目课题研究
		async selectEtt() {
			try {
				this.pageLoading = true;
				this.formThree.operatorId = this.userInfo.userId;
				// this.formThree.schoolCodes = this.schoolCodes;
				let moduleUrl;
				if (this.activeCode == "eduResearch") {
					moduleUrl = "research";
					this.formThree.actType = "research";
				} else if (this.activeCode == "train") {
					moduleUrl = "training";
					this.formThree.actType = "training";
				} else if (this.activeCode == "topicResearch") {
					moduleUrl = "topic";
					this.formThree.actType = "topic";
				}
				let { current, total, size, records } = await postJson(
					"/" + moduleUrl + "/getActiveInfoList",
					this.formThree
				);
				this.dataList = records;
				this.pageLoading = false;
			} catch (err) {
				console.log("err", err);
			}
		},
		//教学设计 学术文章 示范辐射 	//资源分享
		async selectDar() {
			try {
				this.pageLoading = true;
				this.formDar.operatorId = this.userInfo.userId;
				this.formDar.schoolCodes = this.schoolCodes;
				if (this.activeCode == "design") {
					let { records } = await postJson(
						"/teacherDesignInfoController/getTeacherDesignIfo",
						this.formDar
					);
					this.darList = records || [];
				} else if (this.activeCode == "articles") {
					let { records } = await postJson(
						"/teacherArticles/getTeacherArticlesInfo",
						this.formDar
					);
					this.darList = records || [];
				} else if (this.activeCode == "radiation") {
					let { records } = await postJson(
						"/teacherRadiationInfo/getTeacherRadiationInfo",
						this.formDar
					);
					this.darList = records || [];
					//资源分享
				} else if (this.activeCode == "share") {
					let { records } = await postJson("/share/getShareInfoList", {
						module: "",
						operatorId: this.userInfo.userId,
						pageNum: this.formDar.pageNum,
						pageSize: this.formDar.pageSize
					});
					this.darList = records || [];
				}

				this.pageLoading = false;
			} catch (err) {
				this.darList = [];
				console.log("err", err);
				this.pageLoading = false;
			}
		},
		//个人空间
		async getGrkj(pageSize) {
			this.pageLoading = true;
			let { total, records } = await postJson("/planning/getPersonalSpace", {
				userId: this.userInfo.userId,
				pageNum: 1,
				pageSize: pageSize || 6,
				attachType: ""
			});
			records.forEach(i => {
				i.attachUrl = i.attachUrl || "";
				i.attachType = i.attachUrl
					? i.attachUrl.substring(
							i.attachUrl.lastIndexOf(".") + 1,
							i.attachUrl.length
					  )
					: "";
				i.attachName =
					i.attachName ||
					i.attachUrl.substring(
						i.attachUrl.lastIndexOf("/") + 1,
						i.attachUrl.length
					);
			});
			this.dataListKj = records;
			this.pageLoading = false;
		},
		downloadFile(url, name) {
			//确认下载完成 后 进行下载记录保存
			downloadUrlFile(url, name);
		},
		more() {
			if (["eduResearch", "train", "topicResearch"].includes(this.activeCode)) {
				this.formThree.pageSize = 50;
				this.selectEtt();
			} else if (
				["design", "articles", "radiation", "share"].includes(this.activeCode)
			) {
				this.formDar.pageSize = 50;
				this.selectDar();
			} else if (this.activeCode === "grkj") {
				this.getGrkj(100);
			}
		},
		//智能推荐
		async selectTj() {
			this.tjLoading = true;
			this.znForm.schoolCodes = this.schoolCodes;
			this.znForm.userId = this.userInfo.userId;
			let { records } = await postJson(
				"/frontPage/getIntelligentRecommendation",
				this.znForm
			);
			this.dataListTj = records;
			this.tjLoading = false;
		},
		znMore() {
			this.znForm.pageNum = 1;
			this.znForm.pageSize = -1;
			this.selectTj();
		},
		changeType2(code) {
			this.znForm.sortBy = code;
			this.selectTj();
		},
		goZnDetail(i) {
			let module = i.module || this.activeCode;
			//教学设计"design"，学术文章"articles，示范辐射radiation
			if (module == "design") {
				this.$router.push({
					name: "teachingDesignDetail",
					params: { id: i.id }
				});
			} else if (module == "articles") {
				this.$router.push({
					name: "academicEssayDetail",
					params: { id: i.id }
				});
			} else if (module == "radiation") {
				this.$router.push({
					name: "demonstrationRadiationDetail",
					params: { id: i.id }
				});
			}
		}
	},
	watch: {}
};
</script>

<style lang="less" scoped>
.fw {
	font-size: 500px;
	font-weight: 0px;
}
.com {
	padding: 20px;
	.room {
		// border: 1px solid #000;
		background: #fff;
		border-radius: 5px;
		margin-bottom: 22px;
	}
	.tab-list {
		padding: 10px 30px;
		border-bottom: 2px solid #eee;
		.tit {
			font-size: 18px;
			font-weight: 550;
		}
		.more {
			font-size: 14px;
			float: right;
			padding-top: 5px;
			cursor: pointer;
			color: #333;
			font-weight: 400;
		}
		span {
			font-size: 14px;
			margin-left: 20px;
			cursor: pointer;
			padding: 6px 8px;
			border-radius: 8px;
		}
		span:hover {
			color: @color;
			background-color: @hover-bg;
		}
		.active {
			color: @color;
			background-color: @hover-bg;
		}
	}
	.tab-content1 {
		padding: 15px;
		padding-bottom: 20px;
		.score {
			min-height: 295px;
			max-height: 720px;
			overflow-y: auto;
			overflow-x: hidden;
			.list-item {
				padding: 6px 16px;
				border-bottom: 1px solid #eee;
				.article-main {
					flex: 1;
				}
			}
		}
	}
	.tab-content2 {
		padding: 10px;
		//智能推荐
		.max-new {
			padding-bottom: 25px;
			min-height: 295px;
			max-height: 465px;
			overflow-y: auto;
			overflow-x: hidden;
			.new-list {
				cursor: pointer;
				border-bottom: 1px solid rgb(216, 213, 213);
				padding: 5px 7px;
				.img-left {
					margin-top: 7px;
					margin-right: 15px;
					width: 20px;
					img {
						width: 100%;
					}
					h3 {
						color: @hong;
					}
				}
				h4 {
					width: 450px;
					font-size: 14px;
					color: #333;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.tea-desc {
					margin-top: 2px;
					padding: 2px;
					width: 80%;
					img {
						width: 25px;
						height: 25px;
						border-radius: 50%;
						border: 1px solid #eee;
					}
					span {
						margin-top: 4px;
						margin-left: 6px;
						font-size: 14px;
					}
					.school {
						margin-left: 50px;
						margin-top: 6px;
					}
				}
			}
			.new-list:hover {
				border-radius: 8px;
				background-color: rgb(250, 248, 248);
			}
		}
	}
	.space-table {
		padding-bottom: 30px;
		padding: 0px 15px;
		// border: 1px solid #000;
		.del {
			margin: 8px;
			margin-right: 60px;
		}
		.big-icon {
			font-size: 25px;
			color: @color;
			// font-weight: 700;
		}
		.del-btn {
			color: @hong;
		}
	}
}
</style>
